import { useSelector } from 'react-redux';
import { RootState } from '../../redux/reducers';
import { store } from '../../redux/store';

function useSelectedDashboardId(): number | undefined {
  const dashboardId = useSelector((state: RootState): number | undefined =>
    state.application.selectedDashboard,
  );

  return dashboardId;
}

export function getSelectedDashboardId(): number | undefined {
  return store
    .getState()
    .application.selectedDashboard;
}

export default useSelectedDashboardId;